import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthApi } from "./useAuthApi";
import { useIsSuperadmin } from "./useIsSuperadmin";
import { useCurrentUser } from "./useCurrentUser";
import { resetThemeToLight } from "../design-system/utils/theme-utils";
import { tableauAuthCache } from "../services/tableauAuthCache";

/** Window event the app shell listens for to open the switch-organization picker. */
export const SWITCH_TENANT_EVENT = "magicbi:open-switch-tenant";

/** Identity and handlers for SidebarProfileChip, shared by every place the profile menu appears. */
export const useProfileMenuActions = () => {
  const navigate = useNavigate();
  const { logout } = useAuthApi();
  const isSuperadmin = useIsSuperadmin();
  const { name, email, avatarUrl } = useCurrentUser();

  const onLogout = useCallback(async () => {
    try {
      const token = localStorage.getItem("accessToken");
      if (token) await logout(token);
    } catch {
      // best-effort logout; clear client state regardless
    }
    localStorage.clear();
    resetThemeToLight();
    tableauAuthCache.clear();
    navigate("/login");
  }, [logout, navigate]);
  const onSettings = useCallback(() => navigate("/settings"), [navigate]);
  const onSwitchTenant = useCallback(
    () => window.dispatchEvent(new Event(SWITCH_TENANT_EVENT)),
    [],
  );
  const onSignupApprovals = useCallback(() => navigate("/admin/signups"), [navigate]);

  return {
    name: name ?? "",
    email: email ?? undefined,
    avatarUrl,
    onSettings,
    onSwitchTenant,
    onSignupApprovals: isSuperadmin ? onSignupApprovals : undefined,
    onLogout,
  };
};
